import '../../css/style.scss'
import '../../css/leaderboard.scss'
import {EntryShared} from '../../../shared/scripts/EntryShared.ts'
import {UIWHeaderController} from '../ui_html/header/UIWHeaderController.ts'
import {UISidebarController} from '../ui_html/sidebar/UISidebarController.ts'
import {UIWLeaderboardController} from './UIWLeaderboardController.ts'
import {EntrySingletonPageShared} from '../../EntrySingletonPageShared.ts'

void init()

async function init() {
    EntryShared.initializeAudio()

    await EntryShared.initializeEntry()

    const headerController = new UIWHeaderController()
    new UISidebarController()

    new UIWLeaderboardController()

    EntrySingletonPageShared.initializeSocketAndGeneralServices(headerController)
    EntryShared.sendPageVisitAnalyticEvent()
}
